import { collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const deleteTag = async (tagId: string) => {
  const collectionRef = collection(db, "tags");

  await deleteDoc(doc(collectionRef, tagId));
};
